import docsearch from '@docsearch/js';

const config = window.__docsearchConfig;

if (config) {
    document.querySelectorAll('.docsearch-btn').forEach((container) => {
        docsearch({
            ...config,
            container,
        });
    });
}
